// Shared by PersonListItem (sets it), EditHouseholdContent (queries the DOM for it to restore
// focus after a move), and PersonListItem's test mock — so a rename can't drift the three apart.
export const getDraggablePersonTestId = (personId) => `draggable-person-${personId}`
